<ion-card-content class="ion-padding-horizontal-2 ion-padding-vertical-0">
    <app-single-asset-select *ngIf="!to.multi" [scannedAsset]="assets[0]" [props]="$any(props)" [key]="updatedKey"
        (assetsEvent)="saveAssets($event)">
    </app-single-asset-select>

    <app-multi-asset-select *ngIf="to.multi" [scannedAssets]="assets" [props]="$any(props)" [key]="updatedKey"
        (assetsEvent)="saveAssets($event)">
    </app-multi-asset-select>

</ion-card-content>